<ion-backdrop (click)="_bdClick()" [class.backdrop-no-tappable]="!_bdDismiss"></ion-backdrop><div class="modal-wrapper"><div #viewport nav-viewport></div></div>